import { useMemo, useState } from 'react';

import { FilterOnChange } from '@keaze/web/components/filters';
import {
  MultiFilters,
  SearchFilters,
  MobileFiltersData,
} from '../filters.types';
import { generateNumberOfActiveFilters } from '../helpers/generateNumberOfActiveFilters';
import { RadiusData } from './mobile.types';

type UseMobileExpected = {
  drawerOpen: boolean;
  numberOfActiveFilters: number;
  toggleDrawer: () => void;
  onClearAllFilters: () => void;
  onClearFilter: OnClearFilter;
};

type UseMobileArgs = {
  data: MobileFiltersData[];
  radius: RadiusData;
  onChange: FilterOnChange;
};

type UseMobile = (args: UseMobileArgs) => UseMobileExpected;

type OnClearFilter = (name: string) => void;

export const useMobile: UseMobile = ({ data, radius, onChange }) => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const numberOfActiveFilters = generateNumberOfActiveFilters([
    ...data,
    {
      name: 'Radius',
      multiValue: false,
      options: [],
      param: SearchFilters.Radius,
      value: radius.value,
    },
  ]);
  const filtersParams = useMemo(() => data.map(({ param }) => param), [data]);

  const toggleDrawer = () => setDrawerOpen((prevState) => !prevState);

  const handleClearAllFilters = () =>
    onChange(MultiFilters.Mobile, [
      ...filtersParams,
      SearchFilters.Location,
      SearchFilters.Radius,
    ]);

  const handleClearFilter: OnClearFilter = (name) => onChange(name, null);

  return {
    drawerOpen,
    numberOfActiveFilters,
    toggleDrawer,
    onClearAllFilters: handleClearAllFilters,
    onClearFilter: handleClearFilter,
  };
};
